import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import CertificateManager from "./CertificateManager";
import CertificateViewer from "./CertificateViewer";
import { useAuth } from "../../hooks/useAuth";

const CertificateTabs = () => {
  const [activeTab, setActiveTab] = useState<"manager" | "viewer" | null>(null);
  const { hasFeature } = useAuth();


  useEffect(() => {
    if (hasFeature("CERTIFICATE-MANAGER")) {
      setActiveTab("manager");
    } else if (hasFeature("CERTIFICATE-VIEWER")) {
      setActiveTab("viewer");
    }
  }, [hasFeature]);

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tab Navigation */}
      <Box sx={{ display: "flex", borderBottom: "2px solid #eee", mb: 1 }}>
        {hasFeature("CERTIFICATE-MANAGER") && <Button
          onClick={() => setActiveTab("manager")}
          sx={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            color: activeTab === "manager" ? "#E60012" : "#888",
            borderBottom:
              activeTab === "manager"
                ? "3px solid #E60012"
                : "3px solid transparent",
            borderRadius: 0,
            background: "none",
            boxShadow: "none",
            px: 3,
            py: 2,
            textTransform: "none",
          }}
        >
          CERTIFICATE MANAGER
        </Button>}
        {hasFeature("CERTIFICATE-VIEWER") && <Button
          onClick={() => setActiveTab("viewer")}
          sx={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            color: activeTab === "viewer" ? "#E60012" : "#888",
            borderBottom:
              activeTab === "viewer"
                ? "3px solid #E60012"
                : "3px solid transparent",
            borderRadius: 0,
            background: "none",
            boxShadow: "none",
            px: 3,
            py: 2,
            textTransform: "none",
          }}
        >
          CERTIFICATE VIEWER
        </Button>}
      </Box>

      {/* Conditional rendering */}
      {activeTab === "manager" && <CertificateManager />}
      {activeTab === "viewer" && <CertificateViewer />}
    </Box>
  );
};

export default CertificateTabs;
